import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { VehicleModel } from '../models/vehicle.model';
import { VehicleService } from '../services/vehicle.service';

@Component({
    selector: 'app-vehicle-details',
    templateUrl: './vehicle-details.component.html',
    encapsulation: ViewEncapsulation.None
})

export class VehicleDetailsComponent implements OnInit {
    form: FormGroup;
    idVehicle: number;
    mainImage: any;
    vehicle: VehicleModel = new VehicleModel();
    vehicleImages: any[];

    mainSlideConfig = {
        "slidesToShow": 1,
        "slidesToScroll": 1,
        "dots": true,
        "lazyLoad": "ondemand",
        "infinite": false
    };

    smallSlideConfig = {
        "slidesToShow": 4,
        "slidesToScroll": 1,
        "dots": false,
        "lazyLoad": "ondemand",
        "infinite": false
    };

    constructor(
        private route: ActivatedRoute,
        private vehicleService: VehicleService,
        private fb: FormBuilder) {

        this.form = fb.group({
            Name: ['', [Validators.required]],
            Document: ['', [Validators.required]],
            Email: ['', [Validators.required], Validators.email],
            Phone: ['', [Validators.required]],
            Birthdate: ['', [Validators.required]]
        });
    }

    ngOnInit(): void {
        this.idVehicle = parseInt(this.route.snapshot.params.idVehicle);
        this.getVehicleById(this.idVehicle);

    }

    getVehicleById(idVehicle: number) {
        this.vehicleService.getVehicleById(idVehicle).subscribe(data => {
            this.vehicle = data[0];
            const el = document.querySelector('body');
            el.scrollTop = 0;
        });

        this.vehicleService.getVehicleImagesByIdVehicle(idVehicle).subscribe(images => {
            this.mainImage = { IdVehicle: 0, ImageURL: this.vehicle.FeatureImage, Name: this.vehicle.Manufacturer + " " + this.vehicle.Name };

            this.vehicleImages = images;
            this.vehicleImages.push(this.mainImage);
        });
    }

    lnkVehicleMessage(): void {
        var carName = this.vehicle.Manufacturer + "%20" + this.vehicle.Name;

        var customerName = this.form.controls['Name'].value;
        var customerDocument = this.form.controls['Document'].value;
        var customerEmail = this.form.controls['Email'].value;
        var customerPhone = this.form.controls['Phone'].value;
        var customerBirthdate = this.form.controls['Birthdate'].value;

        var link = "https://api.whatsapp.com/send?phone=551936310101&text=Ol%C3%A1%2C%20tenho%20interesse%20no%20ve%C3%ADculo%3A%20*" +
            carName +
            "*%0a%0aCliente: *" + customerName +
            "*%0aCPF: *" + customerDocument +
            "*%0aEmail: *" + customerEmail +
            "*%0aTelefone: *" + customerPhone +
            "*%0aNascimento: *" + customerBirthdate +
            "*";

        window.location.href = link;
    }
}
